import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Онлайн-запись на тренировки | CRM для фитнеса — Planna</title>
          <meta name="description" content="Запись на групповые и индивидуальные занятия. Клиенты видят расписание тренеров и свободные места. Напоминания, абонементы, отчёты. Бесплатно." />
        </Helmet>
        <h1 class="main2">Бронирование помещений с выбором конкретного места на плане</h1>
        <h2 class="main2">Как в самолёте или кинотеатре — клиент сам выбирает, где сидеть</h2>
        <div class="main3">Как это работает:</div>
        <div class="main3">Вы загружаете план помещения, создаёте зоны (VIP, обычные места, места у окна), каждое место настраивается индивидуально:</div>
        <div class="w40">
          <ul class="main3">
            <li>Доступно/недоступно</li>
            <li>Повышенная цена (например, у окна)</li>
            <li>Специальные отметки (доступно для инвалидов)</li>
          </ul>
        </div>

        <div class="w40 main3">
        Для конференц-залов:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Схема рассадки (театр, класс, круглые столы)</li>
            <li>Возможность выбрать конкретную конфигурацию</li>
            <li>Отметки о доступном оборудовании (проектор, флипчарт)</li>
            <li>Выбор дополнительного оборудования в один клик с ценами</li>
          </ul>
        </div>

        <div class="w40 main3">
        Вы можете создать план зала с несколькими зонами: VIP-зона с отдельными столами, основная зона с рядами, зона для инвалидов. Для каждого места настраивается цена, статус и доступность. Клиенты бронируют конкретные места, а не просто билеты на мероприятие
        </div>

        <div class="w40 main3">
        Преимущества:
        </div>
        <div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
          <thead><tr><th>Для владельца площадки</th><th>Для посетителя</th></tr></thead>
          <tbody>
            <tr>
            <td>Максимальное заполнение пространства</td><td>Выбор удобного места</td>
            </tr><tr>
            <td>Дифференциация цен (VIP, обычные)</td><td>Уверенность, что место будет</td>
            </tr><tr>
            <td>Аналитика популярности зон</td><td>Возможность сидеть с компанией рядом</td>
            </tr><tr>
            <td>Управление мероприятиями</td><td>Прозрачность рассадки заранее</td>
            </tr><tr>
            <td>Интеграция с билетной системой</td><td>Лёгкое бронирование с телефона</td>
            </tr>
          </tbody></table>

        </div>

        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (места)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
      </div>
    );
  }
}
